import {library} from '@fortawesome/fontawesome-svg-core'
import * as icon from '@fortawesome/free-solid-svg-icons'

library.add(
  icon.faPlay,
  icon.faPause,
  icon.faExpand,
  icon.faCompress,
  icon.faCommentAlt,
  icon.faUndoAlt,
  icon.faRedoAlt,
  icon.faVolumeMute,
  icon.faVolumeOff,
  icon.faVolumeDown,
  icon.faVolumeUp,
  icon.faCheck,
)

export {FontAwesomeIcon as default} from '@fortawesome/react-fontawesome'
